import { render } from "./RegistrationClinicStepThree.vue?vue&type=template&id=6afcd2b5&scoped=true"
import script from "./RegistrationClinicStepThree.vue?vue&type=script&lang=js"
export * from "./RegistrationClinicStepThree.vue?vue&type=script&lang=js"

import "./RegistrationClinicStepThree.vue?vue&type=style&index=0&id=6afcd2b5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afcd2b5"]])

export default __exports__